import { formatThousandAndUnit, keepOnePercentOrLine, keepTwoOrLine } from '@/utils/utils';
import { Empty, Tooltip } from '@maxtropy/components';
import { apiV2WaterMapDataCardDataPost } from '@maxtropy/device-customer-apis-v2';
import { useRequest } from 'ahooks';
import React, { FC, useMemo } from 'react';
import styles from './index.module.scss';
import { formatName } from '@/pages/WgqAllMaps/utils';

interface ICenterTopBox {
  className?: string;
  fixLeft?: boolean;
}

const CenterTopBox: FC<ICenterTopBox> = props => {
  const { className, fixLeft } = props;

  // 地图卡片
  const { data: cardData, loading } = useRequest(async () => {
    return await apiV2WaterMapDataCardDataPost({});
  });

  const isEmpty = useMemo(() => {
    return !cardData || cardData.list?.length === 0;
  }, [cardData]);

  // 排除污水
  const waterExcept = useMemo(() => {
    return cardData?.list?.filter(c => c.energyMediumId !== 2006);
  }, [cardData]);

  // 污水排量
  const waterSewage = useMemo(() => {
    return cardData?.list?.find(item => item.energyMediumId === 2006);
  }, [cardData]);

  return (
    <div
      className={`${styles.row} ${className || ''}`}
      style={{ flex: fixLeft ? 2 : 'unset', padding: fixLeft ? 0 : '0 32px' }}
    >
      <div className={styles.left_noMap} style={{ width: '100%' }}>
        <div className={styles.leftCard}>
          <div className={styles.columnItem} style={{ width: fixLeft ? 0 : 260 }}>
            <div className={styles.itemTitle}>本月总用水</div>
            <div className={styles.itemValue}>
              {isEmpty ? (
                <Empty imageStyle={{ height: 40 }} />
              ) : (
                waterExcept?.map(item => (
                  <div className={styles.item_medium} key={item.energyMediumId}>
                    <div className={styles.item_medium_label}>{formatName(item.energyMediumName)}(m³):</div>
                    <Tooltip title={formatThousandAndUnit(item.monthTotal).value}>
                      <div className={styles.item_medium_value}>
                        {formatThousandAndUnit(item.monthTotal).value}
                        <span className={styles.unit}>{formatThousandAndUnit(item.monthTotal).unit}</span>
                      </div>
                    </Tooltip>
                    <div>{keepOnePercentOrLine(item.monthProportion)}%</div>
                  </div>
                ))
              )}
            </div>
          </div>

          <div className={styles.columnItem} style={{ width: fixLeft ? 0 : 260 }}>
            <div className={styles.itemTitle}>本年总用水</div>
            <div className={styles.itemValue}>
              {isEmpty ? (
                <Empty imageStyle={{ height: 40 }} />
              ) : (
                // 排除污水
                waterExcept?.map(item => (
                  <div className={styles.item_medium} key={item.energyMediumId}>
                    <div className={styles.item_medium_label}>{formatName(item.energyMediumName)}(m³):</div>
                    <Tooltip title={formatThousandAndUnit(item.yearTotal).value}>
                      <div className={styles.item_medium_value}>
                        {formatThousandAndUnit(item.yearTotal).value}
                        <span className={styles.unit}>{formatThousandAndUnit(item.yearTotal).unit}</span>
                      </div>
                    </Tooltip>
                    <div>{keepOnePercentOrLine(item.yearProportion)}%</div>
                  </div>
                ))
              )}
            </div>
          </div>

          {/* <div className={styles.columnItem} style={{ width: fixLeft ? 0 : 220 }}>
            <div className={styles.itemTitle}>污水排放量</div>
            <div className={styles.itemValue}>
              {waterSewage ? (
                <>
                  <div className={styles.item_medium}>
                    <div className={styles.item_medium_label}>本月(m³):</div>
                    <div className={styles.item_medium_value}>
                      <Tooltip title={formatThousandAndUnit(waterSewage?.monthTotal).value}>
                        {formatThousandAndUnit(waterSewage?.monthTotal).value}
                        <span className={styles.unit}>{formatThousandAndUnit(waterSewage?.monthTotal).unit}</span>
                      </Tooltip>
                    </div>
                  </div>
                  <div className={styles.item_medium}>
                    <div className={styles.item_medium_label}>本年(m³):</div>
                    <Tooltip title={formatThousandAndUnit(waterSewage?.yearTotal).value}>
                      <div className={styles.item_medium_value}>
                        {formatThousandAndUnit(waterSewage?.yearTotal).value}
                        <span className={styles.unit}>{formatThousandAndUnit(waterSewage?.yearTotal).unit}</span>
                      </div>
                    </Tooltip>
                  </div>
                </>
              ) : (
                <Empty imageStyle={{ height: 40 }} />
              )}
            </div>
          </div> */}
        </div>
      </div>
    </div>
  );
};

export default CenterTopBox;
